export default __webpack_public_path__ + "d1fde924e79d6d76d1e3fffaff099623.mp3";